import React from 'react';
import { PageMetaTags as PageMeta } from '@cp/shared/metaTags';
import { useHelmet } from 'src/shared/helmet';
import { MetaTagsProps } from './model';

export const PageMetaTags = ({ isClosedForRobots, renderConfig }: MetaTagsProps) => {
  const Helmet = useHelmet();
  return <PageMeta HeadComponent={Helmet} isClosedForRobots={isClosedForRobots} tagsConfig={renderConfig} />;
};
